module.exports = __webpack_public_path__ + "static/basecamp-6754262dbba821bdfd6a85c55acdcf43.svg";